import GeneratedResourceShareServiceApi from "./generated/GeneratedResourceShareServiceApi"

class ResourceShareServiceApi extends GeneratedResourceShareServiceApi {

}

export const resourceShareServiceApi = new ResourceShareServiceApi()
